export default function Fallback({ node }) {
	return <div></div>; // TODO: handle with an error page?
}
